import { useSelector, useDispatch } from "react-redux";
import useColors from "../customHooks/useColors";
import BaseParagraph from "../baseComponents/baseParagraph";
import { useEffect } from "react";
import BaseHeading from "../baseComponents/baseHeading";
import { asyncActions as userAsyncActions } from "../store/slices/userSlice";

const MessageDetails = ({ selectedMessageID, onMessageSeen }) => {
  const userState = useSelector((state) => state.userState);
  const dispatch = useDispatch();

  const [currentColors] = useColors();

  const messages = userState.messages;

  const message = messages.find((msg) => msg.id === selectedMessageID);
  const { address, body, id, points_date, seen, sent, subject } = message;

  useEffect(() => {
    const markMessageAsSeen = async () => {
      const response = await dispatch(
        userAsyncActions.markMessageAsSeen({
          messageID: selectedMessageID,
        })
      );
      let parsedResponse = JSON.parse(response.payload.P_RESULT);

      console.log(parsedResponse);
      onMessageSeen();
    };
    if (seen == "N") {
      markMessageAsSeen();
    }
  }, []);

  return (
    <>
      <BaseParagraph translate={false}>{message.body}</BaseParagraph>
    </>
  );
};

export default MessageDetails;
